import React from 'react';

// Import necessary components
import { Lightbox, PageSidebar, PageTitle } from '../../../components';

// Import icons for visual representation
import { FaArrowRight, FaCaretRight, FaCheck, FaCircleNotch } from 'react-icons/fa';

// Import useLocation to access route state
import { useLocation } from 'react-router-dom';



const PortfolioSingle = () => {

  // Get Portfolio details passed via router state
  const location = useLocation();
  const portfolio = location.state;

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={portfolio.title} page={"Portfolio Single"} />

      <section className='portfolio-single page-single'>

        <div className='portfolio-info page-info'>

          {/* Portfolio Image */}
          <div className='image'>
            <img src={portfolio.image} alt={portfolio.title} />
          </div>

          <div className='content'>

            {/* Portfolio Title */}
            <h3 className='main-heading'>{portfolio.title}</h3>

            {/* Portfolio Description */}
            {portfolio.paragraphs.map((paragraph, index) => (
              <p key={index} className={index === 0 ? 'important' : ''}>
                {paragraph}
              </p>
            ))}

            {/* Portfolio Image Gallery */}
            <Lightbox images={portfolio.gallery} />

            {/* Technologies and Methods Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Technologies and Methods:</h3>
              <p>Core technologies and strategies used to develop and implement the {portfolio.title} solution effectively and efficiently.</p>

              {/* List of Technologies */}
              <ul>
                {portfolio.technologies.map((technology, index) => {
                  return <li key={index}><FaArrowRight className='icon' />{technology}</li>
                })}
              </ul>

            </div>

            {/* Project Challenges Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Project Challenges:</h3>
              <p>Key technical and strategic challenges faced during the execution of the {portfolio.title} project and how they were addressed.</p>

              {/* List of Project Challenges */}
              <ul>
                {portfolio.challenges.map((challenge, index) => {
                  return <li key={index}><FaCheck className='icon' />{challenge}</li>
                })}
              </ul>

            </div>

            {/* Project Solution Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Project Solutions:</h3>
              <p>We tackled these project challenges with innovative tech-driven solutions tailored to client needs and objectives.</p>

              {/* Project Solutions List */}
              <ul>
                {portfolio.solutions.map((solution, index) => {
                  return <li key={index}><FaCaretRight className='icon' />{solution}</li>
                })}
              </ul>

            </div>

            {/* Project Results Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Project Results:</h3>
              <p>The project achieved measurable outcomes, on-time delivery, and strong client satisfaction backed by data insights.</p>

              {/* Project Results */}
              <ul>
                {portfolio.results.map((result, index) => {
                  return <li key={index}><FaCircleNotch className='icon' />{result}</li>
                })}
              </ul>

            </div>

          </div>

        </div>

        {/* Sidebar with Portfolio details */}
        <PageSidebar
          heading={'Portfolio'}
          details={portfolio.details}
        />

      </section>

    </> 
  );
}

export default PortfolioSingle;